import Template from "./template";

export default {
  path: ":id",
  element: <Template />,
  loader: async () => {
    return {};
  },
};
